<h2 class="head">
    Personalizza il tuo regalo
</h2>

<div class="row" [formGroup]="form">
    <mat-form-field class="w-100" maxlength="160">
        <mat-label>Messaggio personalizzato</mat-label>
        <textarea matInput placeholder="No emoji" [formControl]="messaggioFormControl"></textarea>
        <mat-hint align="end">{{form.value.messaggio.length}} / 160
        </mat-hint>
    </mat-form-field>
</div>


<div class="continua">
    <hr class="mb-1 divisore">
    <h2 class="head mb-1 mt-2">
        {{'base.riepilogo' | translate}}
    </h2>
    <div class="riepilogo">
        <div class="riepilogo__line">
            <div class="riepilogo__label">
                Nr. posti
            </div>
            <div class="riepilogo__value">
                <div class="flex-buttons">
                    <button mat-stroked-button class="buttonPosti" (click)="adultiMeno()">
                        <span class="material-symbols-outlined">
                            remove
                        </span>
                    </button>
                    <label class="labelposti">{{adulti}}</label>
                    <button mat-stroked-button class="buttonPosti" (click)="adultiPiu()">
                        <span class="material-symbols-outlined">
                            add
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="riepilogo__line">
            <div class="riepilogo__label">
                {{ 'step1.totale' | translate }}
            </div>
            <div class="riepilogo__value total">
                € {{totale | number:'1.2-2'}}
            </div>
        </div>
    </div>


    <div class="flex-actions mt-2">
        <button class="btn btn-red" (click)="continua()" [disabled]="!form.valid">
            {{ 'step1.acquistaora' | translate}}
            <span class="material-symbols-outlined">
                shopping_bag
            </span>
        </button>
    </div>

</div>